import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Colors, CreditDetails } from 'Types';
import { clx, currencyFormatter } from 'Utils';
import { Card, Badge, FontAwesome } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';
import { SkeletonSubscriptionPlan } from '../skeleton/SkeletonSubscriptionPlan';

interface Props {
	credit: CreditDetails | undefined;
	isLoading: boolean;
}

export const SubscriptionPlan: FC<Props> = ({ credit, isLoading }) => {
	const { t } = useTranslation();

	return isLoading ? (
		<SkeletonSubscriptionPlan />
	) : (
		<Col>
			<Card>
				<h6 className={clx(styles.row, 'text-gray-3 fs-6 fw-400')}>
					<span className={styles.rowLabel}>
						{t('title.subscription-plan')}
					</span>
				</h6>
				<Row>
					<Col sm={12}>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.name')}
							</span>
							<span className="fs-6">
								{credit?.subscriptionPlanInfo?.name ?? '---'}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.code')}
							</span>
							<span>
								{
									credit?.subscriptionPlanInfo
										?.subscriptionPlanCode
								}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.duration')}
							</span>
							<span>
								{`${
									credit?.subscriptionPlanInfo?.durationDays
								} ${t('title.days')}`}
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								{t('label.type')}
							</span>
							<span>
								<Badge
									color={
										credit?.subscriptionPlanInfo?.type === 1
											? Colors.premium
											: Colors.tertiary
									}
									className="gap-2">
									{credit?.subscriptionPlanInfo?.type ===
										1 && (
										<FontAwesome icon={'medal'} size="lg" />
									)}
									{credit?.subscriptionPlanInfo?.type === 1
										? t('button.premium')
										: t('button.standard')}
								</Badge>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={clx(styles.rowLabel, 'fw-500')}>
								{t('label.price')}
							</span>
							<span className="fw-500">
								{currencyFormatter(
									credit?.subscriptionPlanInfo?.price ?? 0
								)}
							</span>
						</div>
					</Col>
				</Row>
			</Card>
		</Col>
	);
};
